import {Disposable, Environment} from 'relay-runtime';
import {commitMutation, graphql} from 'react-relay';
import Util from '../../forecast-app/shared/util/util';
import {RunNovaAgentDryRunInput, RunNovaAgentDryRunMutation} from './__generated__/RunNovaAgentDryRunMutation.graphql';
import {MutationInput, RelayOnCompleted, RelayOnError} from '../MutationTypes';

// A dry run: the agent is run against a real task and the answer is returned to the author, with
// nothing written back to the task. Nothing is added to the Relay store — a dry run is not a record,
// it is one answer the Test tab holds in component state until the author navigates away.
const mutation = graphql`
	mutation RunNovaAgentDryRunMutation($input: RunNovaAgentDryRunInput!) {
		runNovaAgentDryRun(input: $input) {
			result {
				output
				ranAt
				run {
					modelDisplayName
				}
			}
		}
	}
`;

function commit(
	environment: Environment,
	input: MutationInput<RunNovaAgentDryRunInput>,
	onSuccess?: RelayOnCompleted<RunNovaAgentDryRunMutation>,
	onError?: RelayOnError
): Disposable {
	const variables = {input: {csrfToken: Util.getCsrfValue(), socketClientId: Util.getClientId(), ...input}};

	return commitMutation<RunNovaAgentDryRunMutation>(environment, {
		mutation,
		variables,
		onCompleted: onSuccess,
		onError: onError,
	});
}

export default {commit};
